var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 12,
    viewBox: "0 0 80 12",
    fill: "#1BBC34",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#1BBC34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 5.77345L70 11.547L70 -5.29527e-05L80 5.77345ZM0 5.77344L1.74846e-07 4.77344L71 4.77345L71 5.77345L71 6.77345L-1.74846e-07 6.77344L0 5.77344Z",
    fill: "#1BBC34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGreen);
export default __webpack_public_path__ + "static/media/arrow-right-green.74bc7ab03737a54f95d110da558a823d.svg";
export { ForwardRef as ReactComponent };